import { Link } from "react-router-dom";
import { NAV_LINKS } from "../../data/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="grain relative bg-teal-anchor text-paper">
      <div className="relative z-10 mx-auto max-w-7xl px-5 sm:px-8 py-20">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <h3 className="font-serif text-3xl tracking-tight">Tanonshop</h3>
            <p className="mt-4 max-w-sm text-paper/70 leading-relaxed">
              Handmade custom cushion covers, cut to fit and built to last. Over twenty years of
              craftsmanship for homes, RVs, boats and everything in between.
            </p>
            <Link
              to="/custom-order"
              data-testid="footer-quote-btn"
              className="mt-8 inline-flex items-center rounded-sm border border-paper/40 px-6 py-3 text-xs font-semibold uppercase tracking-[0.2em] text-paper transition-all duration-200 hover:bg-paper hover:text-teal-anchor"
            >
              Request a Custom Quote
            </Link>
          </div>

          <div className="md:col-span-3 md:col-start-8">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-paper/50">Explore</p>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-paper/80 hover:text-paper link-underline">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-paper/50">Get in Touch</p>
            <ul className="mt-5 space-y-3 text-paper/80">
              <li><a href="mailto:tanonshop@gmail.com" className="link-underline">tanonshop@gmail.com</a></li>
              <li>Mon–Fri · 9–5</li>
              <li>Nationwide shipping</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-3 border-t border-paper/15 pt-8 text-sm text-paper/50 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} Tanonshop. All rights reserved.</p>
          <p>Custom quotes only — no online payments.</p>
        </div>
      </div>
    </footer>
  );
}
